import React from 'react';
import { useTrackSection } from '../utils/useTrackSection';
const cld = (path: string) => `https://res.cloudinary.com/dowzlbqlz/image/upload/f_auto,q_auto,w_220/${path}`;
const tomes = [{
  number: '01',
  title: 'Primera Consulta',
  desc: 'Cómo ordenar la entrevista inicial, definir prioridades y cerrar cada consulta con próximos pasos claros.',
  image: cld('v1779330121/hf_20260521_003226_65703239-5516-43cd-ad3f-b4085e790bf6_pv6jhc.webp'),
  alt: 'Tomo 1 — Primera Consulta'
}, {
  number: '02',
  title: 'Diseño del Plan',
  desc: 'Cómo crear planes más claros y sostenibles según la realidad de cada paciente.',
  image: cld('v1779330123/hf_20260521_004347_60af8bea-f6d4-43cd-b8be-57b623628a7b_oaxzcf.webp'),
  alt: 'Tomo 2 — Diseño del Plan'
}, {
  number: '03',
  title: 'Seguimiento',
  desc: 'Cómo organizar controles y tomar mejores decisiones más allá del peso.',
  image: cld('v1779330128/hf_20260521_021358_2bee0cb1-ec46-4938-aecf-84d40ae67f60_g9k531.webp'),
  alt: 'Tomo 3 — Seguimiento'
}, {
  number: '04',
  title: 'Educación Alimentaria',
  desc: 'Cómo explicar mejor, ordenar la información y acompañar sin saturar al paciente.',
  image: cld('v1779330131/hf_20260521_020929_33937014-a79c-4998-8399-7890f1ed1207_wryy1j.webp'),
  alt: 'Tomo 4 — Educación Alimentaria'
}, {
  number: '05',
  title: 'Consulta Real',
  desc: 'Cómo adaptar tus sesiones a pacientes reales sin perder estructura ni claridad profesional.',
  image: cld('v1779330134/hf_20260521_020749_48b03105-419f-4765-83c0-2aeecd9abe20_cbt0q7.webp'),
  alt: 'Tomo 5 — Consulta Real'
}, {
  number: '06',
  title: 'Sistema Profesional',
  desc: 'Cómo ordenar tu forma de trabajar para no depender del caos, la memoria o la improvisación.',
  image: cld('v1779330136/hf_20260521_021826_723860d2-3d10-42db-8d0a-b6678912ecd3_ecpsoq.webp'),
  alt: 'Tomo 6 — Sistema Profesional'
}];
export function WhatYouGet() {
  useTrackSection('what-you-get', 'What You Get Section');
  return <section id="what-you-get" className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(240,253,244) 0%, rgb(240,253,244) 50%, rgb(248,250,252) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-222">
      <div className="mx-auto max-w-4xl" data-id="element-223">
        <h2 className="text-2xl font-black text-center text-gray-900 m-0 mb-2" data-id="element-224">
          Qué vas a encontrar dentro del{' '}
          <span className="text-green-700" data-id="element-225">Megapack</span>
        </h2>

        <p className="text-center text-sm text-gray-500 m-0 mb-8" data-id="element-226">
          6 tomos pensados para ayudarte a ordenar cada etapa de tu trabajo:
          desde la primera consulta hasta el seguimiento y la organización del
          consultorio.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-227">
          {tomes.map(tome => <div key={tome.number} className="flex gap-3 bg-white rounded-xl p-3 shadow-sm" style={{
          border: '1px solid rgba(34,197,94,0.20)'
        }} data-id="element-228">
              <div className="w-20 shrink-0 rounded-lg overflow-hidden border border-green-700/20 shadow-sm" data-id="element-229">
                <img src={tome.image} alt={tome.alt} width={220} height={293} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-230" />
              </div>

              <div className="flex-1 min-w-0" data-id="element-231">
                <span className="inline-flex mb-2 text-[10px] font-black text-green-700 bg-green-700/5 border border-green-600/20 rounded-full px-2 py-0.5" data-id="element-232">
                  Tomo {tome.number}
                </span>

                <h3 className="text-sm font-black text-gray-900 m-0 mb-1" data-id="element-233">
                  {tome.title}
                </h3>

                <p className="text-xs text-gray-500 m-0 leading-5" data-id="element-234">
                  {tome.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}